import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {IntermediatePriceAdjustment} from "../components/order-pricing/pricing-adjustments/pricing-adjustments.component";
import {Observable} from "rxjs";
import {IntermediatePriceAdjustmentsFetchService} from "../components/order-pricing/pricing-adjustments/intermediate-price-adjustments-fetch.service";

@Injectable()
export class IntermediatePriceAdjustmentsResolver implements Resolve<IntermediatePriceAdjustment[]> {

	constructor(private fetchService: IntermediatePriceAdjustmentsFetchService) {
	}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IntermediatePriceAdjustment[]> {
		return this.fetchService.fetch();
	}
}
